import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import IconArrowDown from '@adv-mt/mt-svg-icons/lib/ArrowDownMedium'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body2} from '@adv-mt/ui/typography'

import {BASE_CLASS} from './config.js'

const PriceDropLabel = ({priceDrop}) => {
  const {i18n} = useContext(Context)

  if (!priceDrop) return <Body2 className={`${BASE_CLASS}-cashLabel`}>{i18n.t('COMMON_CASH')}</Body2>

  const percentage = Math.abs(priceDrop.percentage)

  return (
    <div className={`${BASE_CLASS}-discount`}>
      <div
        role="img"
        className={`${BASE_CLASS}-discountPercentage`}
        aria-label={i18n.t('PRICE_DROP_PERCENTAGE_A11Y', {percentage})}
      >
        <Icon size={ICON_SIZES.SM} className={`${BASE_CLASS}-discountPercentageIcon`}>
          <IconArrowDown size={ICON_SIZES.SM} />
        </Icon>
        <Body2 highlight className={`${BASE_CLASS}-discountPercentageValue`}>
          {percentage}%
        </Body2>
      </div>
      <Body2 highlight className={`${BASE_CLASS}-discountOriginalPrice`}>
        {i18n.c(priceDrop.originalPrice)}
      </Body2>
    </div>
  )
}

PriceDropLabel.displayName = 'PriceDropLabel'
PriceDropLabel.propTypes = {
  priceDrop: PropTypes.shape({
    originalPrice: PropTypes.number,
    percentage: PropTypes.number
  })
}

export default PriceDropLabel
